import React from 'react';
import { IStyle } from 'Styles';
export interface HeaderBarProps {
  title: string;
}

const HeaderTitleBar = (props: HeaderBarProps) => {
  const { title } = props;
  return (
    <div id='headertitlebar-container' style={styles.mainContainer}>
      <div id={`headertitlebar-${title}`} style={styles.title}>{title}</div>
    </div>
  );
};

const styles: IStyle = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '10px',
    marginBottom: '10px',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: 'large',
    marginLeft: '2%',
  },
};
export default HeaderTitleBar;
